/****   request.js   ****/
// 导入axios
import axios from 'axios'
// 使用element-ui Message做消息提醒
import {
	Message
} from 'element-ui';

import utils from './utils.js'

//import store from '../store/index.js'


// 是否需要登录，当掉线时，弹窗通知
// 黄耿智：2022-12-23
var isNeedLogin = false;

// 声明一个 Map 用于存储每个请求的标识 和 取消函数
const pending = new Map()
/**
 * 添加请求
 * @param {Object} config
 */
const addPending = (config) => {
	const url = [
		config.method,
		config.url,
		JSON.stringify(config.params),
		JSON.stringify(config.data)
	].join('&')
	config.cancelToken = config.cancelToken || new axios.CancelToken(cancel => {
		if (!pending.has(url)) { // 如果 pending 中不存在当前请求，则添加进去
			pending.set(url, cancel)
		}
	})
}
/**
 * 移除请求
 * @param {Object} config
 */
const removePending = (config) => {
	const url = [
		config.method,
		config.url,
		JSON.stringify(config.params),
		JSON.stringify(config.data)
	].join('&')
	if (pending.has(url)) { // 如果在 pending 中存在当前请求标识，需要取消当前请求，并且移除
		const cancel = pending.get(url)
		cancel(url)
		pending.delete(url)
	}
}
/**
 * 清空 pending 中的请求（在路由跳转时调用）
 */
export const clearPending = () => {
	for (const [url, cancel] of pending) {
		cancel(url)
	}
	pending.clear()
}

//1. 创建新的axios实例，
const service = axios.create({
	baseURL: process.env.BASE_API,
	// 超时时间 单位是ms，这里设置了1分钟的超时时间
	timeout: 60 * 1000
})
// 2.请求拦截器
service.interceptors.request.use(config => {

	// removePending(config) // 在请求开始前，对之前的请求做检查取消操作
	// addPending(config) // 将当前请求添加到 pending 中
	//发请求前做的一些处理，数据转化，配置请求头,设置token,设置loading等，根据需求去添加
	// 如果是文件上传就不用转json

	config.data = config.headers ? config.data : JSON.stringify(config.data); //数据转化,也可以使用qs转换
	// console.log("config",config);
	// // // 根据特定规则生成Token
	// var token = handle.productionToken(config.data)
	// console.log("token",token);
	// // // 加密请求参数
	// config.data = handle.encrypt(config.data);
	// console.log("config",config.data);

	config.headers = config.headers || {
		'Content-Type': 'application/json' //'application/x-www-form-urlencoded' //配置请求头
	}

	let token = localStorage.getItem('adminToken')
	if (token) {
		config.headers["adminToken"] = token
	}

	config.method = config.method
	//注意使用token的时候需要引入cookie方法或者用本地localStorage等方法，推荐js-cookie
	// var token = 1; //获取UserId的缓存
	// if (token) {
	// 	// config.params = {'token':token} //如果要求携带在参数中
	// 	config.headers.UserId = token; //如果要求携带在请求头中
	// }

	return config
}, error => {
	Promise.reject(error)
})

// 3.响应拦截器
service.interceptors.response.use(response => {
	//接收到响应数据并成功后的一些共有的处理，关闭loading等
	// 解密
	// console.log(response)
	// response.data = handle.decrypt(response.data);
	// response.data = JSON.parse(response.data);

	// console.log("ddddddddddddddddddddddddddddddddddddddddddddddddddd",response);
	// console.log("response.data",response.data)
	// console.log("response.data.data",response.data.data)
	// console.log("response.data.data.code",response.data.data.code)
	// 检测到未登录，黄耿智：2022-07-31
	if(response && response.data && response.data.code == 999){
		console.log("response 检测到未登录",response);
		localStorage.removeItem('adminToken')
		localStorage.removeItem('adminUserInfo')
		window.location.href = '/#/login'
	}

	return response
}, error => {
	console.log(error);
	/***** 接收到异常响应的处理开始 *****/
	if (error && error.response) {
		// 1.公共错误处理
		// 2.根据响应码具体处理
		switch (error.response.status) {
			case 400:
				error.message = '错误请求'
				break;
			case 401:
				error.message = '未授权，请重新登录'
				break;
			case 403:
				error.message = '拒绝访问'
				break;
			case 404:
				error.message = '请求错误,未找到该资源'
				break;
			case 405:
				error.message = '请求方法未允许'
				break;
			case 408:
				error.message = '请求超时'
				break;
			case 500:
				error.message = '服务器端出错'
				break;
			case 501:
				error.message = '网络未实现'
				break;
			case 502:
				error.message = '网络错误'
				break;
			case 503:
				error.message = '服务不可用'
				break;
			case 504:
				error.message = '网络超时'
				break;
			case 505:
				error.message = 'http版本不支持该请求'
				break;
			case 999://增加，黄耿智：2022-07-31
				error.message = '请重新登录'
				break;
			default:
				error.message = `连接错误${error.response.status}`
		}
	}
	else {
		// 超时处理
		if (JSON.stringify(error).includes('timeout')) {
			Message.error('服务器响应超时，请刷新当前页')
		}
		// error.message = '连接服务器失败'
	}

	// Message.error(error.message)
	/***** 处理结束 *****/
	//如果不需要错误处理，以上的处理过程都可省略
	return Promise.resolve(error.response)
})

export default service



// WEBPACK FOOTER //
// ./src/utils/java-request.js